import { Component } from '@angular/core';
import { NavController, LoadingController } from 'ionic-angular';

// O provider para se comunicar com o servidor online
import { ApiProvider } from '../../providers/api/api';

// O provider para os dados do cliente
import { AuthProvider } from '../../providers/auth/auth';

import { Storage } from '@ionic/storage';

import { TranslateMsgProvider } from '../../providers/translate-msg/translate-msg';

@Component({
	selector: 'page-regras',
  	templateUrl: 'regras.html',
})


export class RegrasPage {

	empresa = {nome: '', imagem: '', regras: '', validade: '', promocao: '' };

	constructor(public navCtrl: NavController, private _apiService: ApiProvider, private loadingCtrl: LoadingController, private _auth: AuthProvider, private storage: Storage, private _msg: TranslateMsgProvider)
	{
		let loading = this.loadingCtrl.create({
            content: this._msg.getMsg('CARREGANDO')+'...'
        });
        loading.present();

        /* Busca informações da empresa */
        this.storage.get('id_empresa_escolhida').then((val) => {
            this.storage.get('id_cliente').then((val2) => {
            	this._apiService.getInformacoesEmpresa({id_empresa_escolhida: val, id_cliente:val2}).subscribe(arg => {
                    // console.log(arg);
                    this.empresa.imagem = arg.config.imagem;
                    this.empresa.regras = arg.config.regras;
                    this.empresa.validade = arg.config.validade;
                    this.empresa.promocao = arg.config.premio;
                    this.empresa.nome = arg.empresa.nome;
        			loading.dismiss();
                });
            });
       });


    }

    // Executar sempre que a página for aberta, mesmo se for voltando
    ionViewDidEnter()
    {
        // Confirma login sempre que entrar na pagina
        this._auth.confirmaLogin();
        this._auth.checkempresa();
    }

}



// WEBPACK FOOTER //
// ./src/pages/regras/regras.ts